import React from 'react';
import { Plus, Trash2 } from 'lucide-react';

interface Coordinator {
  name: string;
  email: string;
}

interface CoordinatorSectionProps {
  coordinators: Coordinator[];
  onChange: (coordinators: Coordinator[]) => void;
}

export const CoordinatorSection: React.FC<CoordinatorSectionProps> = ({
  coordinators,
  onChange,
}) => {
  const addCoordinator = () => {
    onChange([...coordinators, { name: '', email: '' }]);
  };

  const removeCoordinator = (index: number) => {
    const updated = coordinators.filter((_, i) => i !== index);
    onChange(updated);
  };

  const updateCoordinator = (index: number, field: keyof Coordinator, value: string) => {
    const updated = coordinators.map((coordinator, i) =>
      i === index ? { ...coordinator, [field]: value } : coordinator
    );
    onChange(updated);
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <label className="block text-sm font-medium text-gray-700">
          Coordenadores
        </label>
        <button
          type="button"
          onClick={addCoordinator}
          className="inline-flex items-center gap-1 px-3 py-1 text-sm bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          aria-label="Adicionar coordenador"
        >
          <Plus className="w-4 h-4" />
          <span>Adicionar</span>
        </button>
      </div>

      {coordinators.length === 0 && (
        <p className="text-sm text-gray-500 italic">Nenhum coordenador cadastrado</p>
      )}

      {coordinators.map((coordinator, index) => (
        <div
          key={index}
          className="p-4 border border-gray-200 rounded-lg bg-gray-50 space-y-3"
        >
          <div className="flex items-start justify-between gap-3">
            <div className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-3">
              <div>
                <label className="block text-sm font-medium text-gray-600 mb-1">
                  Nome do Coordenador
                </label>
                <input
                  type="text"
                  value={coordinator.name}
                  onChange={(e) => updateCoordinator(index, 'name', e.target.value)}
                  className="w-full px-3 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Digite o nome do coordenador"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600 mb-1">
                  E-mail
                </label>
                <input
                  type="email"
                  value={coordinator.email}
                  onChange={(e) => updateCoordinator(index, 'email', e.target.value)}
                  className="w-full px-3 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Digite o e-mail"
                />
              </div>
            </div>
            <button
              type="button"
              onClick={() => removeCoordinator(index)}
              className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
              aria-label={`Remover coordenador ${index + 1}`}
            >
              <Trash2 className="w-4 h-4" />
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};